import React from 'react';
import { connect } from 'react-redux';
import StyledContainer from './list.styled';
import List from './list';
import Title from '../../../Components/Common/pageTitle';
import { getCorpList } from '../../../Reducer/Modules/service';

class CorpListPage extends React.PureComponent {
    componentDidMount = () => {
        this.props.fetchList();
    };

    render() {
        return (
            <StyledContainer>
                <Title title='사설 구급업체 목록' />
                <List {...this.props} />
            </StyledContainer>
        );
    }
}
const mapStateToProps = ({ app, auth, service }) => ({
    app,
    auth,
    service
});

const mapDispatchToProps = dispatch => ({
    fetchList: () => dispatch(getCorpList())
});

export default connect(mapStateToProps, mapDispatchToProps)(CorpListPage);
